<script>
import ResultDisplay from "@homepage/components/pageStyles/noLimitLotto/ResultDisplay.vue";
import Countdown from "@homepage/components/Countdown.vue";
import {generateImageMapFor} from "@homepage/helpers/image";
import PrizesList from "@homepage/components/PrizesList.vue";

export default {
	name: 'NoLimitBoard',
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	components: {
		PrizesList,
		ResultDisplay,
		Countdown
	},
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	data() {
		return {
			timeToShowPrizesPage: 8000,
			timeToShowEachLotteryResultPage: 5000,
			lotteryEntriesPerPage: 2
		};
	},
	computed: {
		timeToShowResultsPage() {
			const timeToShowEachPage = this.timeToShowEachLotteryResultPage / 1000;

			return Math.ceil(this.generalInformation.lotteriesResultsEntries.length / this.lotteryEntriesPerPage) * timeToShowEachPage * 1000;
		}
	},
	beforeCreate() {
		this.$emit('change-style', {backgroundImage: require('@/assets/img/nolimit/background.jpg')});
	}
}
</script>

<template>
	<v-row justify="center">
		<v-col cols="11">
			<v-row id="header-row">
				<v-col cols="4" class="rounded-tl-xl">
					<v-img id="logo" height="120" width="400" contain
								 :src="require('@/assets/img/nolimit/logo.png')">
					</v-img>
				</v-col>
				<v-col cols="4">
					<v-row class="pick-numbers" no-gutters>
						<v-col class="text-center"><span class="headers"> PICKS</span></v-col>
						<v-col class="text-center"><span class="headers">NUMBERS</span></v-col>
					</v-row>
				</v-col>
				<v-col cols="4" class="text-center rounded-tr-xl">
					<span class="headers">
						PAYOUTS
					</span>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					cols="4"
					class="red-wine--bg rounded-bl-xl"
				>
					<v-row no-gutters>
						<countdown
							id="upcoming-result"
							class="text-center mt-5"
							:sortition="generalInformation.sortition">
							<template #default='{sortition}'>
								<v-flex md3>
									<h1 class='font-weight-bold text-uppercase'>Next draw in</h1>
								</v-flex>
								<v-flex md3>
									<h2 id='next-sortition' class='font-weight-bold'>{{ sortition.name }}</h2>
								</v-flex>
								<v-flex md3>
									<span id='time-left' v-if='sortition.timeLeft'
												class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
									<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
								</v-flex>
							</template>
						</countdown>
					</v-row>

					<v-row no-gutters>
						<v-col cols="12">
							<div class="text-center"><span>Winning Numbers</span></div>
							<result-display
								v-for="result in generalInformation.results.slice(0, 1)"
								:key="result.sortition.id"
								:result="result"
								white
							>
							</result-display>
						</v-col>
					</v-row>
				</v-col>
				<v-col
					cols="4"
					class="white--bg"
				>
					<result-display
						v-for="result in generalInformation.results.slice(1,3)"
						:key="result.sortition.id"
						:result="result"
					>
					</result-display>
				</v-col>

				<v-col
					cols="4"
					class="red-wine--bg rounded-br-xl"
				>
					<prizes-list :general-information='generalInformation'>
						<template #prize-row='{prize}'>
							<v-col class='prize-row white--bg rounded-lg' cols='12'>
								<v-row no-gutters class='py-1'>
									<v-col class='prize-name text-center' cols='6'>
										{{ prize.name }} - 1X:
									</v-col>
									<v-col class='prize-amount text-center' cols='6'>
										{{ prize.amount }}
									</v-col>
								</v-row>
							</v-col>
						</template>
					</prizes-list>
				</v-col>
			</v-row>
		</v-col>
		<v-col id="page-url" cols="12" class="text-center py-0">
			<span>Visit our page nolimitlot.com</span>
		</v-col>
	</v-row>
</template>

<style scoped lang="scss">
@font-face {
	font-family: "RobotoBlack";
	src: url("../../../../public/fonts/roboto-black-webfont.woff");
}

$red: #C1003F;
$blue: #0017A1;

* {
	font-family: "RobotoBlack", "Liberation Sans Narrow", serif;
	color: white;
}

#header-row > .col {
	background: $blue;
}

// Not the best way to do it, but it works
#logo {
	position: absolute;
	top: 27px;
	left: 40px;
}

.headers {
	font-size: 1.5rem;
	font-weight: 800;
}

#next-sortition {
	font-size: 2.5rem;
	font-weight: 800;
	line-height: 35px;
	text-align: center;
}

#time-left {
	font-weight: bold;
	font-size: 3.5rem;
	text-align: center;
	color: white;
}

.prize-name {
	color: $red;
	font-family: "RobotoBlack", serif;
	font-size: 1.7rem;
	font-weight: bold;
}

.prize-amount {
	color: $blue;
	font-size: 2rem;
	font-weight: bold;
	font-family: "DonJose", "Liberation Sans Narrow", serif;
}

#page-url {
	font-size: 1.5rem;
	font-weight: 800;
}
</style>
